export default __webpack_public_path__ + "static/media/i6.70e6667a.jpg";